import { Association } from "../../lib/association-store";

export class OrgAzureSubscription extends Association {}
